















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DCard extends Vue {
  @Prop({ type: String, default: () => "" })
  header!: string;

  value = "国内";

  onValueChange() {
    this.$emit("change", this.value);
  }
};
